<template>
  <div class="card mt-0">
    <div class="card-header">
      <h2>Roles</h2>
    </div>
    <div class="card-body">
      <!-- <RoleListRow
        :roleList="roles.current"
        :title="'Current Roles'"
        :accounts="accounts"
        :showUntilField="false"
        @submit="saveRole('current', $event)"
        @move="moveCurrentRoleToPast"
        @create="newRole('current')"
        @cancel="cancel('current', $event)"
      />-->

      <RoleListRow
        :roleList="currentRoles"
        :type="'current'"
        :accounts="accounts"
        ref="row_current"
        @save="saveRole"
        @move="moveCurrentRoleToPast"
      />

      <RoleListRow
        :roleList="pastRoles"
        :type="'past'"
        :accounts="accounts"
        ref="row_past"
        @save="saveRole"
      />

      <!-- <RoleListRow
        :roleList="roles.past"
        :title="'Past Roles'"
        :accounts="accounts"
        :showUntilField="true"
        @submit="saveRole('past', $event)"
        @create="newRole('past')"
        @cancel="cancel('past', $event)"
      />-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import formatDate from "date-fns/format";
import RoleListRow from './RoleListRow';

export default {
  props: ["personId"],

  data() {
    return {
      roles: {},
      accounts: []
    };
  },
  components: {
    RoleListRow,
  },
  methods: {
    cancel(type, entity) {
      entity.isEditing = false;
      this.roles[type] = this.roles[type].filter(role => {return role.id});
    },
    loadRoles() {
      this.roles = {};
      axios.get(`/person/roles/get/${this.personId}`).then(response => {
        response.data.forEach(role => {
          Vue.set(this.roles, role.id, role);
        });
      });
    },
    loadAccounts() {
      axios.get("/person/roles/accounts/").then(response => {
        this.accounts = response.data.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
      });
    },
    saveRole(role) {
      let isNew = role.id === "new";
      let data = {
          title: role.title,
          since: role.since ? role.since : null,
          until: role.until ? role.until : null,
          accountId: role.accountId
        };
      if (!isNew) {
        data.id = role.id;
      }
      axios({
        method: isNew ? "post" : "put",
        url:
          `/person/roles/${(isNew ? "add" : "edit")}/${this.personId}`,
        data,
      }).then(response => {
        const savedRole = response.data;
        Vue.set(this.roles, savedRole.id, savedRole);
        this.$refs['row_' + role.type].cancelEdit();
      });
    },
    moveCurrentRoleToPast(currentRole) {
      if (!window.confirm("Are you sure you want to move this role to 'Past Roles'?")) {
        return;
      }
      let data = currentRole;
      data.until = this.now;
      data.accountId = data.account.id;
      axios({
        method: "put",
        url:
          "/person/roles/edit/" + this.personId,
        data,
      }).then(response => {
        Vue.set(
          this.roles,
          response.data.id,
          response.data,
        );
      });
    }
  },

  created() {
    this.loadRoles();
    this.loadAccounts();
  },

  computed: {
    hasCurrent() {
      return this.roles.current && this.roles.current.length > 0;
    },
    hasPast() {
      return this.roles.past && this.roles.past.length > 0;
    },
    now() {
      return formatDate(new Date(), "yyyy-MM-dd");
    },
    currentRoles() {
      return Object.values(this.roles).filter(role => {
        return role.until === null;
      })
    },
    pastRoles() {
      return Object.values(this.roles).filter(role => {
        return role.until !== null;
      })
    }
  }
};
</script>



// WEBPACK FOOTER //
// assets/js/components/RolesList.vue